/**
 * Pure conversion between SearchState and URL params for the wineries
 * search route. Used by both the web SearchPage and the mobile
 * WineriesExplorer to guarantee deep-link parity across platforms.
 *
 * Per Option B: typed location (region/city) and bounds (n/s/e/w) are
 * mutually exclusive. If both are set on the input state, bounds wins
 * and region/city are dropped.
 */
export const stateToSearchParams = (state) => {
    const p = new URLSearchParams();
    if (state.q)
        p.set('q', state.q);
    if (state.bounds) {
        p.set('n', String(state.bounds.n));
        p.set('s', String(state.bounds.s));
        p.set('e', String(state.bounds.e));
        p.set('w', String(state.bounds.w));
        // Mutual exclusion: bounds wins, drop typed location.
    }
    else {
        if (state.region)
            p.set('region', state.region);
        if (state.city) {
            p.set('city', state.city);
            if (state.cityLat !== undefined)
                p.set('cityLat', String(state.cityLat));
            if (state.cityLng !== undefined)
                p.set('cityLng', String(state.cityLng));
        }
    }
    if (state.venueTypes?.length)
        p.set('venueTypes', state.venueTypes.join(','));
    if (state.atmospheres?.length)
        p.set('atmospheres', state.atmospheres.join(','));
    if (state.amenities?.length)
        p.set('amenities', state.amenities.join(','));
    if (state.sort)
        p.set('sort', state.sort);
    return p;
};
export const stateToUrl = (state) => {
    const qs = stateToSearchParams(state).toString();
    return qs ? `/wineries?${qs}` : '/wineries';
};
